import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

import { assets } from '../../assets/';

const useStyles = makeStyles({});

export default function DistanceSlider() {
  const classes = useStyles();

  const MySlider = withStyles({
    root: {
      color: '#F87733',
    },
    active: {},
  })(Slider);
  console.log(assets);
  return (
    <div>
      <Typography
        id="distance-start-label-slider"
        color="inherit"
        variant="caption"
      >
        <img
          src={assets.icons.placeIcon}
          alt="place_icon"
          style={{
            maxHeight: 16,
            marginRight: 5,
          }}
        />
        Distance max des assets de production
      </Typography>
      <Grid container spacing={2}>
        <Grid item>
          <Typography
            id="distance-start-label-slider"
            color="inherit"
            variant="caption"
          >
            0 km
          </Typography>
        </Grid>
        <Grid item xs>
          <div className={classes.root} style={{ width: 300 }}>
            <MySlider
              aria-label="distance-slider"
              defaultValue={400}
              valueLabelDisplay="auto"
              max={1000}
            />
          </div>
        </Grid>
        <Grid item>
          <Typography
            id="distance-end-label-slider"
            color="inherit"
            variant="caption"
          >
            1000 km
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/commons/DistanceSlider.js